import React from 'react'
import tw from 'twin.macro'
import styled from 'styled-components'

const StyledPromoContainer = styled.div`
  ${tw`flex flex-col md:flex-row items-center justify-center gap-16 p-8 w-full gradient-dark-blue`}
`

const PromoHeader = () => (
  <StyledPromoContainer>
    <p className="text-primary text-12 sm:text-14">
      This website operates solely as a user interface to certain smart contracts and does not warrant, represent, or
      guarantee their functionality, performance, or availability. Users remain responsible for verifying and
      interacting with the underlying smart contracts through any alternative tools or methods should they encounter
      difficulties with this interface.
    </p>
  </StyledPromoContainer>
)

export default PromoHeader
